import { Box, Grid, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonInput from "../../../CommonComponents/CommonInput";
import { images } from "../../../Images/Svg";
const { VerifiedCheck } = images;

const formContents = [
  {
    name: "pan",
    label: "PAN",
    type: "input",
    placeholder: "Enter PAN",
    required: true,
  },
  {
    name: "gst",
    label: "GST",
    type: "input",
    placeholder: "Enter GST",
    required: true,
  },
];

const verifiedDetails = [
  {
    id: "legal_name",
    label: "Legal Name",
    value: "ABC Pvt. Ltd.",
  },
  {
    id: "legal_name",
    label: "Trade Name",
    value: "ABC Pvt. Ltd.",
  },
  {
    id: "city",
    label: "City",
    value: "Mumbai",
  },
  {
    id: "address",
    label: "Address",
    value: "Bhandup West",
  },
  {
    id: "pincode",
    label: "Pincode",
    value: 400078,
  },
  {
    id: "state",
    label: "State",
    value: "Maharashtra",
  },
  {
    id: "nature_of_firm",
    label: "Nature of Firm",
    value: "Proprietorship",
  },
  {
    id: "gst_status",
    label: "GST Status",
    value: "Active",
  },
  {
    id: "centre_jurisdiction",
    label: "Centre Jurisdiction",
    value: "Mumbai West",
  },
  {
    id: "state_jurisdiction",
    label: "State Jurisdiction",
    value: "Maharashtra",
  },
  {
    id: "registration_date",
    label: "Registration Date",
    value: "01/07/2017",
  },
  {
    id: "tax_payer_type",
    label: "Tax Payer Type",
    value: "Regular",
  },
  {
    id: "business_address",
    label: "Additional Business Place Address",
    value: "Haryana",
  },
];

function PanGstDetails({
  setIsBtn1Active,
  setIsBtn2Active,
  saveClicked,
  nextClicked,
  onSaveClick,
  onNextClick,
}) {
  const [details, setDetails] = useState({});

  const onChangeHandler = (e) => {
    const name = e?.target?.name;
    setDetails((prev) => ({
      ...prev,
      [name]: {
        status: "verify",
        value: e?.target?.value,
      },
    }));
  };

  const onVerify = (name) => {
    if (details?.[name]?.status === "verify") {
      setDetails((prev) => ({
        ...prev,
        [name]: {
          status: "verifying",
          value: prev?.[name]?.value,
        },
      }));
      setTimeout(() => {
        setDetails((prev) => ({
          ...prev,
          [name]: {
            status: "verified",
            value: prev?.[name]?.value,
          },
        }));
      }, 2000);
    }
  };

  useEffect(() => {
    if (saveClicked) onSaveClick();
    if (nextClicked) onNextClick();
  }, [saveClicked, nextClicked]);

  useEffect(() => {
    let { pan, gst } = details;
    if (pan?.status === "verified" && gst?.status === "verified") {
      setIsBtn1Active(true);
      setIsBtn2Active(true);
    } else {
      setIsBtn1Active(false);
      setIsBtn2Active(false);
    }
  }, [details]);

  return (
    <Box>
      <Grid container columnSpacing={10} rowGap={2}>
        <Grid item lg={3} md={3} sm={12}>
          {formContents?.map((item) => {
            let status = details?.[item?.name]?.status;
            let value = details?.[item?.name]?.value;
            return (
              <CommonInput
                key={item?.label}
                name={item?.name}
                label={
                  item?.name === "gst"
                    ? details?.["pan"]?.status === "verified"
                      ? item?.label
                      : ""
                    : item?.label
                }
                value={value}
                placeholder={item?.placeholder}
                padding={"0.8rem 1.25rem"}
                backgroundColor={status === "verified" ? "#F5FBF8" : "#ebeef8"}
                verify={
                  value ? (
                    <Typography
                      name={item?.name}
                      sx={{
                        color: "#0084FF",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      onClick={() => onVerify(item?.name)}
                    >
                      {status === "verify" ? (
                        <u>Verify</u>
                      ) : status === "verifying" ? (
                        <>
                          Verify
                          <CircularProgress
                            sx={{
                              marginLeft: "5px",
                              color: "#C8C8C8",
                              width: "1.2rem !important",
                              height: "1.2rem !important",
                            }}
                          />
                        </>
                      ) : (
                        <img src={VerifiedCheck} alt="verifiedIcon" />
                      )}
                    </Typography>
                  ) : (
                    ""
                  )
                }
                focusedStyles={{
                  background: "white",
                  border: "1px solid #5570F1",
                }}
                sx={{
                  display:
                    item?.name === "gst" &&
                    details?.["pan"]?.status !== "verified"
                      ? "none"
                      : "block",
                  marginBottom: "2rem",
                  border:
                    status === "verified"
                      ? "1px solid #F5FBF8"
                      : value
                      ? "1px solid #5570F1"
                      : "1px solid #ebeef8",
                  input: {
                    "&::placeholder": {
                      textOverflow: "ellipsis !important",
                      color: "#5E6366",
                      opacity: 1,
                      fontSize: "1.2rem",
                    },
                    padding: "1rem",
                    fontSize: "1.2rem",
                  },
                }}
                onChange={onChangeHandler}
                removeBackGround={status === "verified" ? null : value}
                required={item?.required}
              />
            );
          })}
        </Grid>
        <Grid
          item
          lg={9}
          md={9}
          sm={12}
          sx={{
            display: details?.["gst"]?.status !== "verified" ? "none" : "block",
          }}
        >
          <Box
            sx={{
              margin: "2px",
              padding: "10px",
              borderRadius: "10px",
              border: "1px solid #32936F",
            }}
          >
            <Grid container>
              {verifiedDetails?.map((item, index) => (
                <Grid
                  key={item?.id}
                  item
                  lg={4}
                  sm={12}
                  sx={{
                    borderBottom:
                      index === verifiedDetails?.length - 1
                        ? "none"
                        : "1px solid #ECEFF1",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inherit",
                      fontSize: "1.2rem",
                      fontWeight: 500,
                      padding: "10px",
                      color: "#5E6366",
                    }}
                  >{`${item?.label} -  ${item?.value}`}</Typography>
                </Grid>
              ))}
            </Grid>
          </Box>
          <span
            style={{
              color: "#E42125",
              fontSize: "1.2rem",
              fontWeight: 500,
              float: "right",
            }}
          >
            NOTE : This information will be pre-filled in the form.
          </span>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PanGstDetails;
